import { combineReducers } from 'redux';

import navReducer from '../components/navigation/navReducer';
import pickListReducer from '../admin/PickList/pickListReducer';
import paymentReducer from '../payment/paymentReducer';
import policyReducer from '../policy/policyReducer';
import quotingReducer from '../quoting/quotingReducer';
import reportReducer from '../report/reportReducer';
import userReducer from '../user/userReducer';
import authReducer from '../auth/authReducer';
import settingsReducer from './settingsReducer';
import questionReducer from './questionReducer';

const reducers = combineReducers({
	nav: navReducer,
	pickList: pickListReducer,
	payment: paymentReducer,
	policy: policyReducer,
	quoting: quotingReducer,
	report: reportReducer,
	user: userReducer,
	auth: authReducer,
	settings: settingsReducer,
	question: questionReducer,
});

export default reducers;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/reducers.ts